import { render } from "./ContextMenuItem.vue?vue&type=template&id=3470b981&scoped=true"
import script from "./ContextMenuItem.vue?vue&type=script&lang=ts"
export * from "./ContextMenuItem.vue?vue&type=script&lang=ts"

import "./ContextMenuItem.vue?vue&type=style&index=0&id=3470b981&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3470b981"

export default script